import {
  CMP_TYPOGRAPHY_UI_VALUE_SM_CAPTION,
  getTypographyStyles,
  SEM_TYPOGRAPHY_ACTION_LG_LABEL,
  SEM_TYPOGRAPHY_ACTION_MD_LABEL,
  SEM_TYPOGRAPHY_ACTION_SM_LABEL,
} from '@oneaudi/unified-web-common';

export enum NumbersSize {
  XSMALL = 'xsmall',
  SMALL = 'small',
  MEDIUM = 'medium',
  LARGE = 'large',
}

const getTypographyBySize = (
  size: 'xsmall' | 'small' | 'medium' | 'large',
  xs: object,
  sm: object,
  md: object,
  lg: object,
) => {
  switch (size) {
    case 'xsmall':
      return getTypographyStyles(xs);
    case 'small':
      return getTypographyStyles(sm);
    case 'medium':
      return getTypographyStyles(md);
    default:
      return getTypographyStyles(lg);
  }
};

export const getFontStyle = (size: NumbersSize) => {
  return getTypographyBySize(
    size,
    CMP_TYPOGRAPHY_UI_VALUE_SM_CAPTION,
    SEM_TYPOGRAPHY_ACTION_SM_LABEL,
    SEM_TYPOGRAPHY_ACTION_MD_LABEL,
    SEM_TYPOGRAPHY_ACTION_LG_LABEL,
  );
};
